export default "__VITE_ASSET__54815203__"